var _rect, _path, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGurgencler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 124,
    viewBox: "0 0 248 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 248,
    height: 124,
    fill: "white",
    fillOpacity: 0.7
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_302_1046)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_302_1046",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 39,
    width: 200,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 39.4436H24V84.5564H224V39.4436Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_302_1046)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_302_1046",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 39,
    width: 200,
    height: 46
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M224 39.4436H24V84.5564H224V39.4436Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_302_1046)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_302_1046",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 40,
    width: 199,
    height: 44
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224 40.9473H25.5038V83.0525H224V40.9473Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_302_1046)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_302_1046",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 40,
    width: 199,
    height: 44
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224 40.9473H25.5038V83.0525H224V40.9473Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_302_1046)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_302_1046",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 40,
    width: 300,
    height: 44
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M324.752 40.9473H25.5038V83.0525H324.752V40.9473Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_302_1046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0004 44.7449H61.9699V77.268H26.0004V44.7449Z",
    fill: "#F26522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0004 44.7449H61.9699V77.268H26.0004V44.7449ZM25.5233 77.7366H62.4487V44.2764H25.5233V77.7366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0475 56.313C55.0475 56.313 55.3255 51.1218 49.3604 51.1218C42.9592 51.1218 33.3668 57.6299 32.9269 65.733C32.8111 67.885 34.2769 67.9664 34.2769 67.9664C34.2769 67.9664 33.6914 69.4323 33.6853 70.7473C33.678 72.4745 33.8547 73.153 33.8547 73.153C33.8547 73.153 34.8983 69.1109 35.5435 67.8846C36.9276 65.2556 39.4456 62.2368 43.4026 60.0004C44.6333 59.3056 48.0998 57.8705 48.98 58.964C50.2631 60.558 45.6147 63.3841 44.1386 64.5305C41.2726 66.7553 36.0249 67.7085 36.0249 67.7085L35.8391 68.05C35.8391 68.05 39.793 67.821 44.3744 65.1873C46.9936 63.682 53.3826 59.8094 51.5158 56.7234C50.2894 54.6988 45.348 56.3717 42.0928 58.5075C37.2737 61.6706 34.614 66.9306 34.614 66.9306C34.614 66.9306 34.2229 62.5088 41.3836 57.0273C43.2449 55.601 47.6763 53.6111 50.0366 53.6111C53.9613 53.6124 55.0475 56.313 55.0475 56.313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5994 53.6785H83.1489V75.7436C79.6452 75.7436 76.7836 74.8953 74.5655 73.1992C72.3461 71.503 70.7554 69.5204 69.7965 67.2517C68.8364 64.9831 68.3563 62.995 68.3563 61.2857C68.3563 59.2827 68.7266 57.3763 69.4699 55.5631C70.2132 53.7515 71.2567 52.1546 72.5989 50.769C73.9429 49.3852 75.517 48.3018 77.3247 47.521C79.131 46.7401 81.0721 46.3489 83.1489 46.3489V48.9328C81.2286 48.9328 79.3302 49.445 77.4509 50.4686C75.572 51.4917 74.0319 52.9371 72.828 54.8026C71.6241 56.6681 71.01 58.801 70.9832 61.1995C70.9832 62.5511 71.2627 63.9276 71.8215 65.3293C72.3802 66.7293 73.1325 68.0037 74.0764 69.1512C75.0218 70.2999 76.0533 71.2111 77.1743 71.8823C78.2952 72.5566 79.3846 72.903 80.4433 72.9216C80.4896 72.8953 80.5415 72.8706 80.5994 72.8445V53.6785Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.981 75.7441H102.432V46.3481H104.981C107.264 46.3481 109.174 46.8183 110.708 47.7553C112.243 48.694 113.421 49.8398 114.242 51.1961C115.063 52.5506 115.633 53.85 115.955 55.0892C116.275 56.33 116.458 57.3753 116.505 58.2235C116.505 59.6715 116.195 61.1312 115.58 62.6017C114.963 64.0716 114.066 65.3766 112.889 66.5156C111.711 67.6541 110.324 68.4557 108.728 68.9213L115.501 75.7446H111.999L106.1 69.7828H104.981V75.7441ZM114.032 58.2235C114.032 57.0366 113.699 55.6964 113.035 54.2001C112.369 52.7038 111.424 51.4265 110.197 50.3669C108.971 49.3085 107.579 48.7802 106.023 48.7802C105.809 48.7802 105.461 48.8048 104.981 48.8561V66.9213C105.105 66.959 105.259 66.9913 105.443 67.0175C105.629 67.0438 105.766 67.0659 105.857 67.0846C106.959 67.0524 108.147 66.7184 109.42 66.0849C110.691 65.45 111.778 64.4688 112.68 63.1419C113.582 61.815 114.032 60.1751 114.032 58.2235Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.291 53.6785H133.841V75.7436C130.337 75.7436 127.477 74.8953 125.258 73.1992C123.038 71.503 121.448 69.5204 120.489 67.2517C119.529 64.9831 119.048 62.995 119.048 61.2857C119.048 59.2827 119.419 57.3763 120.162 55.5631C120.905 53.7515 121.949 52.1546 123.291 50.769C124.635 49.3852 126.209 48.3018 128.017 47.521C129.823 46.7401 131.766 46.3489 133.841 46.3489V48.9328C131.921 48.9328 130.022 49.445 128.143 50.4686C126.264 51.4917 124.724 52.9371 123.52 54.8026C122.316 56.6681 121.702 58.801 121.675 61.1995C121.675 62.5511 121.955 63.9276 122.514 65.3293C123.073 66.7293 123.825 68.0037 124.769 69.1512C125.714 70.2999 126.746 71.2111 127.866 71.8823C128.987 72.5566 130.077 72.903 131.136 72.9216C131.182 72.8953 131.234 72.8706 131.291 72.8445V53.6785Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.887 53.4011H146.035L147.028 55.9846H140.887V73.1612H146.114V75.7446H138.337V55.9846H136.984L136.147 53.4011H138.337V46.3486H146.114V48.8566H140.887V53.4011Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.365 75.7442H149.737V46.1963L157.913 50.4251V46.3495H160.541V75.7442H157.913V53.3243L152.365 50.4633V75.7442Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.74 73.1602H189.918V75.7441H181.11V46.3481H183.74V73.1602Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.501 53.4011H199.648L200.642 55.9846H194.501V73.1612H199.728V75.7446H191.95V55.9846H190.597L189.761 53.4011H191.95V46.3486H199.728V48.8566H194.501V53.4011Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.081 75.7441H203.531V46.3481H206.081C208.364 46.3481 210.272 46.8183 211.808 47.7553C213.342 48.694 214.52 49.8398 215.342 51.1961C216.16 52.5506 216.733 53.85 217.054 55.0892C217.376 56.33 217.558 57.3753 217.604 58.2235C217.604 59.6715 217.294 61.1312 216.679 62.6017C216.062 64.0716 215.166 65.3766 213.988 66.5156C212.809 67.6541 211.424 68.4557 209.828 68.9213L216.601 75.7446H213.097L207.2 69.7828H206.081V75.7441ZM215.132 58.2235C215.132 57.0366 214.799 55.6964 214.134 54.2001C213.468 52.7038 212.523 51.4265 211.296 50.3669C210.07 49.3085 208.68 48.7802 207.121 48.7802C206.908 48.7802 206.56 48.8048 206.081 48.8561V66.9213C206.203 66.959 206.357 66.9913 206.543 67.0175C206.727 67.0438 206.865 67.0659 206.955 67.0846C208.059 67.0524 209.246 66.7184 210.519 66.0849C211.79 65.45 212.877 64.4688 213.779 63.1419C214.681 61.815 215.132 60.1751 215.132 58.2235Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.761 46.1097V48.7315C176.127 48.7315 173.863 49.3022 171.968 50.4455C170.072 51.587 168.647 53.0892 167.69 54.9488C166.734 56.8087 166.239 58.8143 166.206 60.9645C166.239 63.0902 166.734 65.0814 167.69 66.9379C168.647 68.7949 170.071 70.2967 171.963 71.4412C173.854 72.5871 176.12 73.1594 178.761 73.1594V75.7435C176.315 75.7435 174.138 75.3377 172.231 74.523C170.322 73.7099 168.727 72.6018 167.441 71.1989C166.157 69.7947 165.192 68.2093 164.547 66.4427C163.9 64.6764 163.578 62.8517 163.578 60.9696C163.578 59.0877 163.9 57.2179 164.547 55.4385C165.192 53.6592 166.151 52.0691 167.422 50.6678C168.694 49.2678 170.292 48.1586 172.216 47.3378C174.139 46.5188 176.321 46.1097 178.761 46.1097Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.274 76.0366V77.5957C173.274 77.5957 175.411 77.6232 175.49 79.4467C175.557 81.0058 173.274 81.3649 173.274 81.3649V83.0526C173.274 83.0526 177.409 83.0526 177.409 79.4467C177.409 75.549 173.274 76.0366 173.274 76.0366Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6413 71.9072C89.6413 72.4487 89.9207 72.8679 90.4783 73.1612C91.0357 73.4544 91.7016 73.6224 92.4729 73.6678C93.2712 73.63 93.9491 73.4621 94.5066 73.1658C95.0654 72.8696 95.3448 72.449 95.3448 71.9076V46.3486H97.9717V71.9072C97.9717 72.8064 97.7177 73.583 97.2078 74.237C96.6996 74.8908 96.0276 75.3843 95.1937 75.7158C94.3596 76.0472 93.4799 76.2135 92.5521 76.2135C91.6243 76.2135 90.728 76.0472 89.8854 75.7158C89.041 75.3843 88.3647 74.8908 87.8547 74.237C87.3467 73.583 87.0922 72.8064 87.0922 71.9072V46.3486H89.6416L89.6413 71.9072Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.3119 42.315C91.3119 43.0695 90.6875 43.6827 89.9191 43.6827C89.1508 43.6827 88.5264 43.0695 88.5264 42.315C88.5264 41.5605 89.1508 40.9473 89.9191 40.9473C90.6875 40.9473 91.3119 41.5605 91.3119 42.315Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5359 42.315C96.5359 43.0695 95.9131 43.6827 95.1444 43.6827C94.3757 43.6827 93.7517 43.0695 93.7517 42.315C93.7517 41.5605 94.3743 40.9473 95.1444 40.9473C95.9145 40.9473 96.5359 41.5605 96.5359 42.315Z",
    fill: "#231F20"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_302_1046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 45.1128,
    fill: "white",
    transform: "translate(24 39.4436)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGurgencler);
export default __webpack_public_path__ + "static/media/gurgencler.98be3b2995da489e166a9ede814de108.svg";
export { ForwardRef as ReactComponent };